import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "utils/api";

interface User {
  id: number;
}

interface Question {
  id: number;
}

interface Reaction {
  id: number;
  code: string;
  name: string;
}

interface SentimentScore {
  positive: number;
  neutral: number;
  negative: number;
  total: number;
}

interface Comment {
  id: number;
  user: User;
  question: Question;
  body: string;
  createOn: string;
  sentimentScore: SentimentScore;
  reactions: {
    reaction: Reaction;
    value: number;
  }[];
  reactionScore: number;
}

interface CommentsSlice {
  isLoading: boolean;
  positiveReactedComments: Comment[];
  error: string;
}

const initialState: CommentsSlice = {
  isLoading: false,
  positiveReactedComments: [],
  error: "",
};

export const getReactedPositiveComments = createAsyncThunk(
  "getReactedPositiveComments",
  async (id: number) => {
    try {
      const response = await axiosInstance.get(
        `/v1/reports/boards/${id}/reaction/positive-comments`
      );
      return response.data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  }
);

export const reactedPositiveCommentsSlice = createSlice({
  initialState,
  name: "board",
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getReactedPositiveComments.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getReactedPositiveComments.fulfilled, (state, action) => {
        state.isLoading = false;
        state.positiveReactedComments = action.payload;
      })
      .addCase(getReactedPositiveComments.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message as string;
      });
  },
});
